export default __webpack_public_path__ + "static/media/question_13.dea7f9b6.png";